import type { ReactNode } from 'react'
import { ErrorNote } from './ErrorNote'
import { Loading } from './Loading'

/** What a data query looks like from the outside: the shape `useApi` returns. */
export interface QueryLike<T> {
  data?: T
  error?: { message: string; status?: number }
  loading: boolean
  reload: () => void
}

/**
 * The three states of anything that loads: placeholders until the first data, the error with Try again, then the
 * content. Once data exists it stays on screen during a reload. <Screen> and <Drawer> use it; so can a card that
 * loads on its own.
 */
export function QueryState<T>(props: {
  query: QueryLike<T>
  children: (data: T) => ReactNode
  loading?: ReactNode
}) {
  const { data, error, loading, reload } = props.query
  if (error && !data) return <ErrorNote message={error.message} onRetry={reload} />
  if (data === undefined) return <>{loading ? (props.loading ?? <Loading shape="block" />) : null}</>
  return <>{props.children(data)}</>
}
